import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  IEventoGenerico,
  IFilter,
  IPopulate,
  IQueryParam,
  TipoEventoGenerico,
} from 'modelos/src';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { Subscription } from 'rxjs';
import {
  IRegExpSearch,
  IFiltroTabla,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { IEstadoCelda } from '../../../../../auxiliares/tabla/tabla.interfaces';
import { fechaCelda, haceCelda } from '../../../../../auxiliares/tabla/celdas';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { LoginService } from '../../../../login/login.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { TratamientoGenericoComponent } from '../../tratar-evento-generico/tratamiento-generico/tratamiento-generico.component';
import { AsignarGenericoComponent } from '../../../administracion/eventos-tecnicos-genericos/asignar/asignar.component';
import { EventosGenericosHelperService } from '../../helper';
import { DetallesEventoGenericoComponent } from '../../detalles-evento-generico/detalles-evento-generico.component';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

export interface IEventoTecnicoGenericoDispositivoData {
  idDispositivo: string;
  tipoEvento:
    | 'Evento Activo'
    | 'Evento Alarma'
    | 'Evento Tracker'
    | 'Evento Vehiculo'
    | 'Evento Colectivo'
    | 'Evento Luminaria'
    | 'Evento Gateway';
  nombreDispositivo?: string;
}

@Component({
  selector: 'app-eventos-tecnicos-generico-dispositivo',
  templateUrl: './eventos-tecnicos-generico-dispositivo.component.html',
  styleUrl: './eventos-tecnicos-generico-dispositivo.component.scss',
  standalone: false,
})
export class EventosTecnicosGenericoDispositivoComponent
  implements OnInit, OnDestroy
{
  private formularios = inject(FormularioDialogService);
  dialogData = inject<IEventoTecnicoGenericoDispositivoData>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<EventosTecnicosGenericoDispositivoComponent>>(
      MatDialogRef,
    );
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private dialogService = inject(DialogService);
  private service = inject(EventosGenericosHttpService);
  private dialog = inject(MatDialog);
  private cdk = inject(OverlayContainer);
  private el = inject(ElementRef);
  private helperEventos = inject(EventosGenericosHelperService);

  public name = 'EventosTecnicosGenericoDispositivoComponent';
  public dragBoundary: HTMLElement | null = null;
  public datosHistorial: IEventoGenerico[] = [];
  public eventoActivo?: IEventoGenerico;
  public datos$?: Subscription;
  public totalCountHistorial = 0;
  public columnasHistorial?: IColumnas<IEventoGenerico>[];
  public dispositivoNombre: string;

  public search: IRegExpSearch = {
    fields: ['valores.titulo'],
  };
  public filtros: IFiltroTabla[] = [];

  public filterHistorial: IFilter<IEventoGenerico> = {
    estado: 'Finalizado',
    filtrador: 'Servicio Técnico',
  };

  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'detallesTecnicos.tecnico',
      select: 'usuario datosPersonales',
    },
  ];

  public queryHistorial: IQueryParam = {
    filter: JSON.stringify(this.filterHistorial),
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: 10,
    includeChildren: true,
    childrenLevel: 0,
  };

  constructor() {
    const dialogData = this.dialogData;

    this.dispositivoNombre =
      dialogData.nombreDispositivo || 'Dispositivo desconocido';
  }

  public async listar(): Promise<void> {
    const filter: IFilter<IEventoGenerico> = {
      idEntidad: this.dialogData.idDispositivo,
      filtrador: 'Servicio Técnico',
      estado: { $ne: 'Finalizado' },
    };

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      populate: JSON.stringify(this.populate),
      sort: '-fechaCreacion',
      limit: 1,
      includeChildren: true,
      childrenLevel: 0,
    };

    this.datos$?.unsubscribe();
    this.datos$ = this.lista2.eventosGenericos(query, 30).subscribe((data) => {
      this.eventoActivo = data.datos.length > 0 ? data.datos[0] : undefined;
    });
  }

  public async listarHistorial(): Promise<void> {
    const filter: IFilter<IEventoGenerico> = {
      idEntidad: this.dialogData.idDispositivo,
      filtrador: 'Servicio Técnico',
      estado: 'Finalizado',
    };

    this.queryHistorial.filter = JSON.stringify(filter);

    this.lista2.eventosGenericos(this.queryHistorial, 30).subscribe((data) => {
      this.totalCountHistorial = data.totalCount;
      this.datosHistorial = data.datos;
    });
  }

  private getTipoEvento(
    tipoEvento: TipoEventoGenerico,
  ):
    | 'Evento Técnico Alarma'
    | 'Evento Técnico Tracker'
    | 'Evento Técnico Luminaria'
    | 'Evento Técnico Sirena'
    | 'Evento Técnico Gateway' {
    // Devuelvo las versiones técnicas según el tipo de evento
    switch (tipoEvento) {
      case 'Evento Activo':
      case 'Evento Vehiculo':
      case 'Evento Colectivo':
        return 'Evento Técnico Tracker';
      case 'Evento Alarma':
        return 'Evento Técnico Alarma';
      case 'Evento Luminaria':
        return 'Evento Técnico Luminaria';
      case 'Evento Gateway':
        return 'Evento Técnico Gateway';
      case 'Evento Sirena':
        return 'Evento Técnico Sirena';
      default:
        throw new Error(`Tipo de evento no soportado ${tipoEvento}`);
    }
  }

  // Acciones
  public async crear() {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: this.dialogData.idDispositivo,
      tipoEvento: this.getTipoEvento(this.dialogData.tipoEvento),
      categoria: this.helperEventos.obtenerCategoriaTecnica(
        this.dialogData.tipoEvento,
      ),
      idsCQAET:
        LoginService.getCliente()?.config
          ?.idsClientesQuePuedenAtenderEventosTecnicos || [],
    };

    const dialogRef = this.formularios.abrir(
      CrearEditarEventoTecnicoGenericoComponent,
      { tamano: 'grande', data },
    );

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.listar();
        await this.listarHistorial();
      }
    });
  }

  public async editar(dato: IEventoGenerico) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      id: dato._id,
      tipoEvento: dato.tipoEvento,
    };

    const dialogRef = this.formularios.abrir(
      CrearEditarEventoTecnicoGenericoComponent,
      { tamano: 'grande', data },
    );

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.listar();
        await this.listarHistorial();
      }
    });
  }

  public async asignar(evento: IEventoGenerico) {
    const data = {
      id: evento._id,
      idTecnico: evento.detallesTecnicos?.tecnico?._id,
    };

    const dialogRef = this.formularios.abrir(AsignarGenericoComponent, {
      tamano: 'mediano',
      data,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.listar();
        await this.listarHistorial();
      }
    });
  }

  public async atender(data: IEventoGenerico) {
    this.dialog.open(TratamientoGenericoComponent, {
      data: { idEvento: data._id },
      hasBackdrop: false,
      minWidth: '1100px',
      maxWidth: '1500px',
    });
  }

  public verDetalles(evento: IEventoGenerico): void {
    this.formularios.abrir(DetallesEventoGenericoComponent, {
      tamano: 'mediano',
      data: { evento },
      cerrarAfuera: true,
    });
  }

  public async eliminar(dato: IEventoGenerico) {
    const res = await this.dialogService.confirm(
      'Eliminar servicio técnico',
      `¿Querés eliminar el servicio técnico?`,
    );
    if (!res) return;

    try {
      await this.service.delete(dato._id!);
      this.helper.notifSuccess('Servicio técnico eliminado');
      await this.listar();
      await this.listarHistorial();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  private setupDragBoundary(): void {
    const routerElement = document.getElementById('router');

    if (routerElement) {
      this.dragBoundary = routerElement;
    } else {
      const overlayContainer = this.cdk.getContainerElement();
      if (overlayContainer) {
        this.dragBoundary = overlayContainer;
      } else {
        this.dragBoundary = document.body;
      }
    }
  }

  // Un clic en cualquier parte del diálogo lo trae al frente. Va en el host y
  // no como (click) en el contenedor de la plantilla: es una superficie, no un
  // botón.
  @HostListener('click')
  public alClicEnDialogo(): void {
    this.bringToFront();
  }

  public bringToFront(): void {
    const dialogElement = this.el.nativeElement.closest('.cdk-overlay-pane');
    if (dialogElement) {
      const maxZIndex = Math.max(
        ...Array.from(document.querySelectorAll('.cdk-overlay-pane')).map(
          (el) => parseInt(getComputedStyle(el).zIndex || '0', 10),
        ),
        1000,
      );
      (dialogElement as HTMLElement).style.zIndex = (maxZIndex + 1).toString();
    }
  }

  // Fechas con el formato común de los listados (24 h, huso del navegador)
  public fechaCelda = fechaCelda;
  public haceCelda = haceCelda;

  /** Estado del servicio técnico activo (misma píldora que el listado). */
  public estadoServicio(evento?: IEventoGenerico): IEstadoCelda | undefined {
    return EventosGenericosHelperService.estadoServicioTecnico(evento?.estado);
  }

  public cerrar(): void {
    this.dialogRef.close();
  }

  private crearColumnasHistorial() {
    this.columnasHistorial = [
      {
        header: { label: 'Título', sort: 'valores.titulo' },
        row: {
          parse: (row) => row.valores?.titulo,
          noData: 'Sin título',
        },
      },
      {
        header: { label: 'Estado', sort: 'estado' },
        row: {
          estado: (row) =>
            EventosGenericosHelperService.estadoServicioTecnico(row.estado),
          noData: 'Sin estado',
        },
      },
      {
        header: { label: 'Técnico' },
        row: {
          parse: (row) =>
            row.detallesTecnicos?.tecnico?.datosPersonales?.nombre ||
            row.detallesTecnicos?.tecnico?.usuario,
          noData: 'Sin asignar',
        },
      },
      {
        header: { label: 'Fecha', sort: 'fechaCreacion' },
        row: {
          fecha: (row) => row.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      {
        header: { label: 'Acciones' },
        row: {
          acciones: [
            {
              tipo: 'material',
              icon: 'visibility',
              tooltip: 'Ver detalle',
              color: 'primary',
              click: (row: IEventoGenerico) => this.verDetalles(row),
            },
          ],
        },
      },
    ];
  }

  async ngOnInit() {
    this.crearColumnasHistorial();
    this.setupDragBoundary();
    await this.listar();
    await this.listarHistorial();
  }

  ngOnDestroy() {
    this.datos$?.unsubscribe();
  }
}
